import { apiWrapper } from 'apis/CommonApi';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppContext } from 'utils/store';
import * as fireonApi from '../../apis/FireOnApi';
import fireAlarm01 from '../../audio/alarm_sample01.mp3';
import fireAlarm02 from '../../audio/alarm_sample02.mp3';
import fireAlarm03 from '../../audio/alarm_sample03.mp3';
import fireAlarm04 from '../../audio/alarm_sample04.mp3';
import fireAlarm05 from '../../audio/alarm_sample05.mp3';
import fireAlarm06 from '../../audio/alarm_sample06.mp3';

export default function AlarmSettingsComponent(props) {
    return (
        <>
            <div className="viewBoard fireOnBoard tableBoard alarmSettingBoard">
                <TopBoard header={props.header} />
                <MidColumnBoard />
                <TableBoard />
            </div>
        </>
    );
}

const TopBoard = ({ header }) => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    }

    return (
        <>
            <div className="top_board mb">
                <div className="wrap_logo">
                    {/* <img src="" alt="" className="img_logo"> */}
                </div>
                <div className="header_dept">
                    <p className="user">COWORKER</p>
                    <div className="wrap_contr">
                        <Link className="set_contr" to="">
                            <img src="/images/my_btn_mb_w.png" alt="" />
                        </Link>
                    </div>
                </div>
            </div>
            <div className="top_board navi_board">
                <div className="wrap_navi" >
                    <button className="arrow_navi" onClick={handleGoBack}>
                        <i className="x-icon arrow_icon"></i>
                    </button>
                    <p className="title_navi">알람소리 ON/OFF</p>
                </div>
                {header}
            </div>
        </>
    );
};

const MidColumnBoard = () => {
    const location = useLocation();
    const { buildingName, serialNumber, dei } = location.state;

    return (
        <div className="mid_board mid_col_board">
            <div className="wrap_mid_le">
                <p className="title_mid">{buildingName}</p>
            </div>
            <div className="wrap_right">
                <div className="wrap_item_contr">
                    <div className="building_info">
                        <div className="item_info">
                            <p className="txt_info title_info">일련번호</p>
                            <p className="txt_info code_info">{serialNumber}</p>
                        </div>
                        <div className="item_info">
                            <p className="txt_info title_info">DEI 코드</p>
                            <p className="txt_info code_info">{dei}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TableBoard = () => {
    const { id } = useParams();
    const { store: { id: userId } } = useAppContext();
    const navigate = useNavigate();
    const [formData, setFormData] = useState(null);

    useEffect(() => {
        setFormDataProperty("detectorOperation", false);
        setFormDataProperty("accumulatedOperation", false);
        setFormDataProperty("transmitterOperation", false);
        setFormDataProperty("equipmentOutputOperation", false);
        setFormDataProperty("powerFaultAlarm", false);
        setFormDataProperty("controlOperation", false);

        apiWrapper(async () => {
            const { status, data } = await fireonApi.getFireFightingObjectAlarmSetting(userId);
            if (status === true) {
                setFormDataProperty("detectorOperation", data.detectorOperation);
                setFormDataProperty("accumulatedOperation", data.accumulatedOperation);
                setFormDataProperty("transmitterOperation", data.transmitterOperation);
                setFormDataProperty("equipmentOutputOperation", data.equipmentOutputOperation);
                setFormDataProperty("powerFaultAlarm", data.powerFaultAlarm);
                setFormDataProperty("controlOperation", data.controlOperation);
            } else {
                alert(`${data}`);
            }
        });
    }, []);

    const setFormDataProperty = (name, value) => {
        setFormData((currentFormData) => {
            const nextFormData = {
                ...currentFormData,
                [name]: value,
            };
            //console.log(nextFormData);
            return nextFormData;
        });
    };

    const onChange = (e) => {
        let name = e.target.name;
        let value = e.target.checked;
        setFormDataProperty(name, value);
    };

    const handleSave = () => {
        apiWrapper(async () => {
            const requestBody = {
                "detectorOperation": formData.detectorOperation,
                "accumulatedOperation": formData.accumulatedOperation,
                "transmitterOperation": formData.transmitterOperation,
                "equipmentOutputOperation": formData.equipmentOutputOperation,
                "powerFaultAlarm": formData.powerFaultAlarm,
                "controlOperation": formData.controlOperation
            }

            const { status, data } = await fireonApi.updateFireFightingObjectAlarmSetting(userId, requestBody);
            alert(`${data}`);
        });
    }

    const handleCancel = () => {
        navigate(-1);
    }

    return (
        <div className="table_board scroll_board">
            <div className="wrap_table wrap_small_table">
                <div className="containerTable alarmSettingTable">
                    <ul className="head_table">
                        <li><p>화재경보 알람소리 항목</p></li>
                        <li><p>OFF/ON</p></li>
                        <li><p>효과음</p></li>
                    </ul>
                    <div className="body_table">
                        <div className="inner_table_wrap">
                            {formData && (
                                <>
                                    <AlarmRow
                                        name="detectorOperation"
                                        title="화재 입력회로 감지기 동작 발생"
                                        checked={formData.detectorOperation}
                                        audioSrc={fireAlarm01}
                                        onChange={onChange}
                                    />
                                    <AlarmRow
                                        name="accumulatedOperation"
                                        title="화재 입력회로 축적 동작 발생"
                                        checked={formData.accumulatedOperation}
                                        audioSrc={fireAlarm02}
                                        onChange={onChange}
                                    />
                                    <AlarmRow
                                        name="transmitterOperation"
                                        title="화재 입력회로 발신기 동작 발생"
                                        checked={formData.transmitterOperation}
                                        audioSrc={fireAlarm03}
                                        onChange={onChange}
                                    />
                                    <AlarmRow
                                        name="equipmentOutputOperation"
                                        title="설비 출력회로 동작 발생"
                                        checked={formData.equipmentOutputOperation}
                                        audioSrc={fireAlarm04}
                                        onChange={onChange}
                                    />
                                    <AlarmRow
                                        name="powerFaultAlarm"
                                        title="화재수신기 전원/고장 알람 발생"
                                        checked={formData.powerFaultAlarm}
                                        audioSrc={fireAlarm05}
                                        onChange={onChange}
                                    />
                                    <AlarmRow
                                        name="controlOperation"
                                        title="화재수신기 제어 동작 발생"
                                        checked={formData.controlOperation}
                                        audioSrc={fireAlarm06}
                                        onChange={onChange}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="wrap_btn_set">
                <button className="btn_set btn_cancle" onClick={handleCancel}>취소</button>
                <button className="btn_set btn_save" onClick={handleSave}>저장</button>
            </div>
        </div >
    );
};

const AlarmRow = ({ name, title, checked, audioSrc, onChange }) => {
    const audioRef = useRef(null);

    const handlePlay = () => {
        if (audioRef.current) {
            audioRef.current.play();
        }
    }

    return (
        <div className="wrap_table_item">
            <div className="inner_table_item table_item_01">
                <p className="cont_table_item">{title}</p>
            </div>
            <div className="inner_table_item table_item_02">
                <div className="toggle-container">
                    <label className="toggle-switch">
                        <input type="checkbox" className="toggle-input" name={name} checked={checked} onChange={onChange} />
                        <span className="slider"></span>
                    </label>
                </div>
            </div>
            <div className="inner_table_item table_item_03">
                <div className="audio-control">
                    <button className="audio-btn" onClick={handlePlay}>
                        <i className="audio-icon x-icon"></i>
                    </button>
                    <audio ref={audioRef} src={audioSrc} preload="auto"></audio>
                </div>
            </div>
        </div>
    );
};